import React from 'react';
import clsx from 'clsx';
import Button from 'components/shared/Button';
import styles from './Question.module.scss';

function Question({
  title, value, onChange,
}: {
  title: string,
  value?: boolean,
  onChange: (v: boolean) => void
}) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {title}
      </div>
      <Button
        className={clsx(styles.btn, !value && styles.btnActive)}
        onClick={() => onChange(false)}
        secondary={Boolean(value)}
      >
        No
      </Button>
      <Button
        className={clsx(styles.btn, value && styles.btnActive)}
        onClick={() => onChange(true)}
        secondary={!value}
      >
        Yes
      </Button>
    </div>
  )
}
export default Question
